import { render, staticRenderFns } from "./feeDetailConfig.vue?vue&type=template&id=0045024f"
import script from "./feeDetailConfig.vue?vue&type=script&lang=js"
export * from "./feeDetailConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports